<template>
	<div class="content">
		<div class="section">
			<div class="section-tit">문자 발송 (소유주 마케팅)</div>
			<div class="tab-btn">
				<button type="button" class="btn tab" v-bind:class="{ active: tab === 'send' }" @click="tab = 'send'">
					발송
				</button>
				<button type="button" class="btn tab" v-bind:class="{ active: tab === 'hist' }" @click="changeTab('hist')">
					발송이력
				</button>
				<button type="button" class="btn tab" v-bind:class="{ active: tab === 'deny' }" @click="changeTab('deny')">
					수신거부
				</button>
			</div>

			<div class="txt-c--grey mb-1">
				솔라피(CoolSMS) 잔액:
				<b v-if="balanceInfo && balanceInfo.available">{{ fmtNum(balanceInfo.balance) }}원 · 포인트 {{ fmtNum(balanceInfo.point) }}P</b>
				<span v-else-if="balanceInfo">조회 불가 (솔라피 콘솔에서 확인하세요)</span>
				<span v-else>조회 중…</span>
				<button type="button" class="btn btn-xsm btn-secondary ms-2" @click="getBalance">새로고침</button>
			</div>

			<!-- ── 발송 ─────────────────────────────────────────────────── -->
			<div class="tab-con" v-if="tab === 'send'">
				<div class="table-wrap">
					<table class="table">
						<colgroup>
							<col width="12%" /><col width="38%" /><col width="12%" /><col width="38%" />
						</colgroup>
						<tr>
							<th>구분</th>
							<td>
								<label class="input-checkbox">
									<input type="radio" value="N" v-model="rent" @change="clearTargets" />
									<span class="text">매매</span>
								</label>
								<label class="input-checkbox">
									<input type="radio" value="Y" v-model="rent" @change="clearTargets" />
									<span class="text">임대</span>
								</label>
							</td>
							<th>상태</th>
							<td>
								<label class="input-checkbox" v-for="st in stKeys" :key="'st_' + st">
									<input type="checkbox" v-model="stList" :value="st" />
									<span class="checkbox"></span>
									<span class="text">{{ stateLabels[st] }}</span>
								</label>
							</td>
						</tr>
						<tr>
							<th>검색어</th>
							<td>
								<input
									class="form-control"
									type="text"
									placeholder="물건명 / 지번 / 도로명 / 소유주명"
									v-model="keyword"
									@keyup.enter="getTargets"
								/>
							</td>
							<td colspan="2">
								<button type="button" class="btn btn-sm btn-primary" @click="getTargets" :disabled="loading">
									{{ loading ? '불러오는 중…' : '수신자 불러오기' }}
								</button>
							</td>
						</tr>
					</table>
				</div>

				<div class="txt-c--grey mb-1" v-if="targetLoaded">
					매물 {{ targetInfo.rowCnt }}건에서 수신자(휴대폰 기준 중복 제거) {{ targets.length }}명
					<span v-if="targetInfo.denyCnt"> · 수신거부 명단 제외 {{ targetInfo.denyCnt }}명</span>
					— 선택 {{ checkedCnt }}명
				</div>

				<div class="table-wrap" v-if="targets.length" style="max-height: 360px; overflow-y: auto">
					<table class="table">
						<colgroup>
							<col width="6%" /><col width="16%" /><col width="18%" /><col width="12%" />
							<col width="36%" /><col width="12%" />
						</colgroup>
						<tr>
							<th>
								<label class="input-checkbox">
									<input type="checkbox" v-model="allChecked" />
									<span class="checkbox"></span>
								</label>
							</th>
							<th>소유주</th>
							<th>휴대폰</th>
							<th>상태</th>
							<th>대표 물건 (물건번호)</th>
							<th>보유물건</th>
						</tr>
						<tr v-for="t in pagedTargets" :key="'tg_' + t.phone">
							<td>
								<label class="input-checkbox">
									<input type="checkbox" v-model="t.checked" />
									<span class="checkbox"></span>
								</label>
							</td>
							<td>{{ t.owner_name }}</td>
							<td>{{ fmtPhone(t.phone) }}</td>
							<td>{{ stateLabels[t.sell_status] || t.sell_status }}</td>
							<td>{{ t.building_name }} ({{ t.building_uid }})</td>
							<td>{{ t.cnt }}건</td>
						</tr>
					</table>
				</div>

				<div class="mt-1" v-if="targets.length && pageCnt > 1">
					<button type="button" class="btn btn-xsm btn-secondary" :disabled="page <= 1" @click="page--">이전</button>
					<span class="mx-2 txt-c--grey">
						{{ page }} / {{ pageCnt }} 페이지 ({{ pageSize }}명씩 표시 — 맨 위 전체선택은 모든 페이지에 적용)
					</span>
					<button type="button" class="btn btn-xsm btn-secondary" :disabled="page >= pageCnt" @click="page++">다음</button>
				</div>

				<div class="mt-2">
					<textarea
						class="form-control"
						rows="8"
						v-model="msg"
						placeholder="발송 문구를 입력하세요.&#10;광고성 문자는 본문 시작에 (광고), 끝에 무료수신거부 080 번호 표기가 필요합니다."
					></textarea>
					<div class="txt-c--grey mt-1">
						{{ msgBytes }}바이트 · {{ msgKind }}
						<button type="button" class="btn btn-xsm btn-secondary ms-2" @click="fillTemplate">예시 문구 넣기</button>
					</div>
					<div class="txt-c--red" v-if="msg && adWarn">
						⚠ 본문이 '(광고)' 로 시작하지 않습니다 — 광고성 문자는 (광고) 표기가 의무입니다(위반 시 과태료).
					</div>
					<div class="txt-c--red" v-if="msg && optOutWarn">
						⚠ 무료수신거부 안내(080 번호)가 없습니다 — 광고성 문자는 무료 수신거부 방법 표기가 의무입니다.
					</div>
					<div class="txt-c--red" v-if="isNight">
						⚠ 현재 야간(21시~08시)입니다 — 광고성 문자 발송이 차단됩니다.
					</div>
				</div>

				<div class="mt-2">
					<button type="button" class="btn btn-primary" @click="btnSend" :disabled="sending || !checkedCnt || !msg.trim()">
						{{ sending ? '발송 중…' : `선택 ${checkedCnt}명에게 발송` }}
					</button>
				</div>
			</div>

			<!-- ── 발송이력 ─────────────────────────────────────────────── -->
			<div class="tab-con" v-if="tab === 'hist'">
				<div class="table-wrap">
					<table class="table">
						<colgroup>
							<col width="12%" /><col width="7%" /><col width="9%" /><col width="36%" />
							<col width="7%" /><col width="7%" /><col width="7%" /><col width="15%" />
						</colgroup>
						<tr>
							<th>발송일시</th>
							<th>구분</th>
							<th>유형</th>
							<th>문구</th>
							<th>대상</th>
							<th>접수성공</th>
							<th>접수실패</th>
							<th>발송자</th>
						</tr>
						<tr
							v-for="b in histList"
							:key="'hb_' + b.sms_mkt_batch_uid"
							@click="getHistItems(b)"
							style="cursor: pointer"
							v-bind:class="{ 'txt-c--blue': histSel && histSel.sms_mkt_batch_uid === b.sms_mkt_batch_uid }"
						>
							<td>{{ fmtDate(b.reg_date) }}</td>
							<td>{{ b.item_kind === 'rent_building' ? '임대' : '매매' }}</td>
							<td>
								{{ b.msg_kind }} {{ b.msg_bytes }}B<span v-if="b.dev_blocked === 'Y'"> (DEV차단)</span>
								<span v-if="b.send_state === 'sending'" class="txt-c--red"> (미완료)</span>
							</td>
							<td :title="b.msg_text">{{ cut(b.msg_text, 40) }}</td>
							<td>{{ b.total_cnt }}</td>
							<td>{{ b.ok_cnt }}</td>
							<td v-bind:class="{ 'txt-c--red': b.fail_cnt > 0 }">{{ b.fail_cnt }}</td>
							<td>{{ b.reg_mem_name }}</td>
						</tr>
						<tr v-if="!histList.length">
							<td colspan="8">발송 이력이 없습니다.</td>
						</tr>
					</table>
				</div>

				<div v-if="histSel" class="mt-2">
					<div class="txt-c--grey mb-1">
						{{ fmtDate(histSel.reg_date) }} 발송 상세 — 문구 전문:
					</div>
					<pre style="white-space: pre-wrap; background: #f8f9fa; padding: 8px; border-radius: 4px">{{ histSel.msg_text }}</pre>
					<div class="table-wrap" style="max-height: 320px; overflow-y: auto">
						<table class="table">
							<colgroup>
								<col width="15%" /><col width="15%" /><col width="26%" /><col width="8%" /><col width="16%" /><col width="20%" />
							</colgroup>
							<tr>
								<th>소유주</th>
								<th>휴대폰</th>
								<th>물건 (물건번호)</th>
								<th>결과</th>
								<th>실패사유</th>
								<th>그룹ID (CoolSMS 대사용)</th>
							</tr>
							<tr v-for="it in pagedHistItems" :key="'hi_' + it.sms_mkt_item_uid">
								<td>{{ it.owner_name }}</td>
								<td>{{ fmtPhone(it.phone) }}</td>
								<td>{{ it.building_name }} <span v-if="it.building_uid">({{ it.building_uid }})</span></td>
								<td v-bind:class="{ 'txt-c--red': it.status === 'fail' }">
									{{ it.status === 'ok' ? '접수' : it.status === 'dev' ? 'DEV차단' : '실패' }}
								</td>
								<td>{{ it.fail_msg }}</td>
								<td>{{ it.group_id }}</td>
							</tr>
						</table>
					</div>
					<div class="mt-1" v-if="histPageCnt > 1">
						<button type="button" class="btn btn-xsm btn-secondary" :disabled="histPage <= 1" @click="histPage--">이전</button>
						<span class="mx-2 txt-c--grey">{{ histPage }} / {{ histPageCnt }} 페이지 ({{ pageSize }}명씩 표시)</span>
						<button type="button" class="btn btn-xsm btn-secondary" :disabled="histPage >= histPageCnt" @click="histPage++">다음</button>
					</div>
				</div>
			</div>

			<!-- ── 수신거부 ─────────────────────────────────────────────── -->
			<div class="tab-con" v-if="tab === 'deny'">
				<div class="txt-c--grey mb-1">
					※ 여기 등록된 번호는 수신자 목록에서 자동 제외되고, 발송 직전 서버에서도 한 번 더 걸러집니다.
					080 무료수신거부 회신·전화 요청을 받으면 바로 등록하세요.
				</div>
				<div class="table-wrap">
					<table class="table">
						<colgroup>
							<col width="20%" /><col width="34%" /><col width="14%" /><col width="18%" /><col width="14%" />
						</colgroup>
						<tr>
							<th>전화번호</th>
							<th>메모</th>
							<th>등록자</th>
							<th>등록일</th>
							<th>관리</th>
						</tr>
						<tr>
							<td><input class="form-control sm" type="text" placeholder="010-0000-0000" v-model="denyAdd.phone" /></td>
							<td><input class="form-control sm" type="text" placeholder="거부 사유/출처" v-model="denyAdd.memo" maxlength="200" /></td>
							<td colspan="3">
								<button type="button" class="btn btn-xsm btn-primary" @click="btnDenyAdd">추가</button>
							</td>
						</tr>
						<tr v-for="d in denyList" :key="'dn_' + d.sms_mkt_deny_uid">
							<td>{{ fmtPhone(d.phone) }}</td>
							<td>{{ d.memo }}</td>
							<td>{{ d.reg_mem_name }}</td>
							<td>{{ fmtDate(d.reg_date) }}</td>
							<td>
								<button type="button" class="btn btn-xsm btn-secondary" @click="btnDenyDel(d)">삭제</button>
							</td>
						</tr>
						<tr v-if="!denyList.length">
							<td colspan="5">등록된 수신거부 번호가 없습니다.</td>
						</tr>
					</table>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'SystemAdmin17',
	data() {
		return {
			tab: 'send',
			// 발송
			rent: 'N',
			stKeys: ['done', 'ready', 'hold', 'sell'],
			stList: ['done', 'ready', 'hold', 'sell'],
			keyword: '',
			loading: false,
			targetLoaded: false,
			targets: [],
			targetInfo: { rowCnt: 0, denyCnt: 0 },
			// 실데이터 수신자가 만 단위(매매 약 1.8만)라 표는 페이지로 나눠 그린다 — 전체 렌더 시 탭 프리즈.
			page: 1,
			pageSize: 100,
			// 목록을 불러온 시점의 구분 스냅샷 — 발송 payload 는 라디오 현재값이 아니라 이것을 쓴다
			// (불러오기 진행 중 라디오를 바꾸면 목록과 구분이 어긋나는 것 방지).
			targetRent: 'N',
			reqSeq: 0,
			msg: '',
			sending: false,
			// 이력
			histList: [],
			histSel: null,
			histItems: [],
			histPage: 1,
			// 수신거부
			denyList: [],
			denyAdd: { phone: '', memo: '' },
			// 솔라피 잔액/포인트 (null=조회 중)
			balanceInfo: null,
			balSeq: 0,
		};
	},
	created() {
		this.getBalance();
	},
	computed: {
		stateLabels() {
			return this.rent === 'Y' ? this.$ITEM_STATE2 : this.$ITEM_STATE;
		},
		checkedCnt() {
			return this.targets.filter(t => t.checked).length;
		},
		pageCnt() {
			return Math.max(1, Math.ceil(this.targets.length / this.pageSize));
		},
		pagedTargets() {
			const s = (this.page - 1) * this.pageSize;
			return this.targets.slice(s, s + this.pageSize);
		},
		histPageCnt() {
			return Math.max(1, Math.ceil(this.histItems.length / this.pageSize));
		},
		pagedHistItems() {
			const s = (this.histPage - 1) * this.pageSize;
			return this.histItems.slice(s, s + this.pageSize);
		},
		allChecked: {
			get() {
				return this.targets.length > 0 && this.targets.every(t => t.checked);
			},
			set(v) {
				this.targets.forEach(t => (t.checked = v));
			},
		},
		msgBytes() {
			let n = 0;
			for (const ch of this.msg) n += ch.codePointAt(0) > 127 ? 2 : 1;
			return n;
		},
		msgKind() {
			return this.msgBytes <= 90 ? 'SMS(단문)' : 'LMS(장문)';
		},
		adWarn() {
			return !this.msg.trim().startsWith('(광고)');
		},
		optOutWarn() {
			return !(this.msg.includes('수신거부') || this.msg.includes('080'));
		},
		isNight() {
			const h = new Date().getHours();
			return h >= 21 || h < 8;
		},
	},
	methods: {
		getBalance() {
			// 진입 시·발송 후·수동 새로고침이 겹칠 수 있다 — 늦게 도착한 이전 응답이
			// 최신 값을 덮지 않도록 시퀀스 가드(getTargets 와 동일 패턴).
			const seq = ++this.balSeq;
			this.$apiGET('/admin/api/sms/mkt/balance').then(re => {
				if (seq !== this.balSeq) return;
				if (re && re.ok === true) this.balanceInfo = re;
				else this.balanceInfo = { available: false };
			});
		},
		fmtNum(n) {
			return Number(n || 0).toLocaleString('ko-KR');
		},
		changeTab(t) {
			this.tab = t;
			if (t === 'hist') this.getHist();
			if (t === 'deny') this.getDeny();
		},
		clearTargets() {
			this.targets = [];
			this.targetLoaded = false;
			this.targetInfo = { rowCnt: 0, denyCnt: 0 };
			this.page = 1;
		},
		getTargets() {
			if (!this.stList.length) {
				alert('상태를 1개 이상 선택하세요. (아무것도 선택하지 않으면 대상이 없습니다)');
				return;
			}
			// 연타/필터 변경으로 요청이 겹칠 때 뒤늦게 도착한 이전 응답이 목록을 덮지 않도록 시퀀스 가드.
			const seq = ++this.reqSeq;
			const rentAt = this.rent;
			this.loading = true;
			const q =
				`/admin/api/sms/mkt/targets?rent=${rentAt}` +
				`&stList=${this.stList.join(',')}` +
				`&keyword=${encodeURIComponent(this.keyword || '')}`;
			this.$apiGET(q)
				.then(re => {
					if (seq !== this.reqSeq) return;
					if (!re || re.ok !== true) return;
					this.targets = (re.list || []).map(t => ({ ...t, checked: true }));
					this.targetInfo = { rowCnt: re.rowCnt || 0, denyCnt: re.denyCnt || 0 };
					this.targetLoaded = true;
					this.targetRent = rentAt;
					this.page = 1;
				})
				.finally(() => {
					if (seq === this.reqSeq) this.loading = false;
				});
		},
		fillTemplate() {
			this.msg =
				'(광고) 위온어스 부동산중개법인\n' +
				'안녕하세요, 대표님. 최근 매수 희망 고객 문의가 많아 보유하신 건물의 매각 의향을 여쭙고자 연락드립니다.\n' +
				'매각을 검토 중이시라면 편하신 시간에 연락 부탁드립니다. 최선을 다해 중개하겠습니다.\n' +
				'☎ 02-0000-0000\n' +
				'무료수신거부 080-000-0000';
		},
		btnSend() {
			const list = this.targets.filter(t => t.checked);
			if (!list.length) {
				alert('수신자를 선택하세요.');
				return;
			}
			if (!this.msg.trim()) {
				alert('발송 문구를 입력하세요.');
				return;
			}
			let warn = '';
			if (this.adWarn || this.optOutWarn) {
				warn = '\n\n⚠ 법적 표기 경고가 있습니다((광고) 표기 또는 무료수신거부 080 안내 누락). 광고성 문자라면 표기 없이 발송 시 과태료 대상입니다.';
			}
			if (!confirm(`선택한 ${list.length}명에게 ${this.msgKind} 문자를 발송합니다.${warn}\n\n계속할까요?`)) return;

			this.doSend(list, false);
		},
		doSend(list, force) {
			this.sending = true;
			// 대량 발송은 서버가 청크 순차 호출로 분 단위까지 걸릴 수 있다 — 기본 2분 타임아웃이
			// 발송 도중 끊고 "실패처럼" 보이게 하는 것을 막는다(서버는 계속 진행).
			this.$apiPOST(
				'/admin/api/sms/mkt/send',
				{
					rent: this.targetRent,
					force: force ? 'Y' : 'N',
					msg: this.msg,
					list: list.map(t => ({
						phone: t.phone,
						owner_name: t.owner_name,
						building_uid: t.building_uid,
						building_name: t.building_name,
					})),
				},
				{ timeout: 300000 },
			).then(re => {
				this.sending = false;
				if (re && re.dup === true) {
					if (confirm(`${re.msg}\n\n그래도 다시 발송할까요?`)) this.doSend(list, true);
					return;
				}
				if (!re || re.ok !== true) return;
				let m = `발송 완료 — 대상 ${re.total}명, 접수 성공 ${re.okCnt}, 실패 ${re.failCnt}`;
				if (re.regFail) m += `\n⚠ 통신사 접수 실패 ${re.regFail}건 포함 — 발송이력의 그룹ID로 CoolSMS 콘솔에서 확인하세요.`;
				if (re.abortMsg) m += `\n⚠ 발송 도중 중단됨: ${re.abortMsg} (남은 수신자는 실패로 기록)`;
				if (re.devBlocked) m += '\n(개발 환경이라 실제 발송은 차단되고 이력만 기록되었습니다)';
				if (re.histSaved === false) m += '\n⚠ 발송은 됐으나 이력 확정에 실패했습니다(이력에 미완료로 표시). 관리자에게 문의하세요.';
				alert(m);
				this.getBalance();
				this.changeTab('hist');
			});
		},
		getHist() {
			this.histSel = null;
			this.histItems = [];
			this.$apiGET('/admin/api/sms/mkt/history').then(re => {
				this.histList = Array.isArray(re) ? re : [];
			});
		},
		getHistItems(b) {
			this.histSel = b;
			this.histItems = [];
			this.histPage = 1;
			this.$apiGET(`/admin/api/sms/mkt/history/items?uid=${b.sms_mkt_batch_uid}`).then(re => {
				this.histItems = Array.isArray(re) ? re : [];
			});
		},
		getDeny() {
			this.$apiGET('/admin/api/sms/mkt/deny').then(re => {
				this.denyList = Array.isArray(re) ? re : [];
			});
		},
		btnDenyAdd() {
			const digits = (this.denyAdd.phone || '').replace(/[^0-9]/g, '');
			if (digits.length < 8) {
				alert('전화번호를 확인하세요.');
				return;
			}
			this.$apiPOST('/admin/api/sms/mkt/deny/add', { phone: digits, memo: this.denyAdd.memo }).then(re => {
				if (re !== true) return;
				this.denyAdd = { phone: '', memo: '' };
				this.getDeny();
			});
		},
		btnDenyDel(d) {
			if (!confirm(`${this.fmtPhone(d.phone)} 번호를 수신거부 명단에서 삭제할까요?\n삭제하면 다음 발송부터 다시 수신 대상이 됩니다.`)) return;
			this.$apiPOST('/admin/api/sms/mkt/deny/del', { uid: d.sms_mkt_deny_uid }).then(re => {
				if (re !== true) return;
				this.getDeny();
			});
		},
		fmtPhone(p) {
			const s = String(p || '');
			if (/^01\d{9}$/.test(s)) return `${s.slice(0, 3)}-${s.slice(3, 7)}-${s.slice(7)}`;
			if (/^01\d{8}$/.test(s)) return `${s.slice(0, 3)}-${s.slice(3, 6)}-${s.slice(6)}`;
			return s;
		},
		fmtDate(v) {
			// mysql2 가 DATETIME 을 UTC ISO 문자열로 직렬화한다 — 문자열을 그대로 자르면
			// 9시간 이른 시각이 표시된다. Date 로 파싱해 로컬(KST) 시각으로 보여준다.
			if (!v) return '';
			const d = new Date(v);
			if (isNaN(d.getTime())) return String(v).replace('T', ' ').slice(0, 16);
			const p = n => String(n).padStart(2, '0');
			return `${d.getFullYear()}-${p(d.getMonth() + 1)}-${p(d.getDate())} ${p(d.getHours())}:${p(d.getMinutes())}`;
		},
		cut(s, n) {
			const t = String(s || '').replace(/\n/g, ' ');
			return t.length > n ? t.slice(0, n) + '…' : t;
		},
	},
};
</script>

<style></style>
